import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';

import {StateProvider, StateObserver} from '../context/state.js';
import {findOrCreate} from '../service/state.js';

/**
 * | Phase | Description                                          |
 * | ----- | ---------------------------------------------------- |
 * | Link  | Provide the state each time an origin state changes. |
 *
 * @group DOM Attribute
 */
const name = 'out-state';

AttributeSetup(name, () => {
  const watch = StateObserver(attributeSelector(name));
  const provide = StateProvider();

  AttributeLink(name, (element, value) =>
    watch(element, (element, origin) => provide(element, findOrCreate(element, origin, value))),
  );
});

export {name as OUT_STATE};
